import useSWR, {SWRConfiguration} from 'swr';
import useSWRMutation, {SWRMutationConfiguration} from 'swr/mutation';
import {DjangoError, PaginatedRequest} from 'utils/types/store';
import letrusAPI from '../axiosInstance';
import {Contest, ContestSchool, ContestSignupData, ContestUser} from './types';

export function fetchContestRequest(
  swrConfig?: SWRConfiguration<PaginatedRequest<Contest[]>>,
) {
  return useSWR<PaginatedRequest<Contest[]>>(
    `api/v1/student_contests/`,
    (url) => letrusAPI(url).then((res) => res.data),
    {...swrConfig, revalidateOnFocus: false},
  );
}

export function acceptContestRequest(
  swrConfig?: SWRMutationConfiguration<Contest, string, string, {id: number}>,
) {
  return useSWRMutation<Contest, string, string, {id: number}>(
    `api/v1/student_contests`,
    (url, {arg}) =>
      letrusAPI(`${url}/${arg.id}/answer/`, {
        method: 'post',
        data: {accepted: true},
      }).then((res) => res.data),
    {...swrConfig, throwOnError: false},
  );
}

export function contestSignupRequest() {
  return useSWRMutation<ContestUser, DjangoError, string, ContestSignupData>(
    '/contest_signup/',
    async (url, {arg}) =>
      letrusAPI(url, {method: 'post', data: arg}).then((res) => res.data),
    {throwOnError: false},
  );
}

export function validateContestCodeRequest(
  swrConfig?: SWRMutationConfiguration<
    ContestSchool,
    string,
    string,
    {access_code: string}
  >,
) {
  return useSWRMutation<ContestSchool, string, string, {access_code: string}>(
    `/check_contest_access_code/`,
    (url, {arg}) =>
      letrusAPI(url, {
        method: 'post',
        data: arg,
      }).then((res) => res.data),
    {...swrConfig, throwOnError: false},
  );
}
